module.exports = __webpack_public_path__ + "img/cremonese-logo-icon.706b545c.png";